module.exports = __webpack_public_path__ + "static/media/trial1_1.98f52df7.png";